export const AliasServices = [
  { id: 'fireblocks', name: 'Fireblocks' },
  { id: 'kraken', name: 'Kraken' },
]
